import { render, staticRenderFns } from "./ScreeningListIframe.vue?vue&type=template&id=5b172af1&"
import script from "./ScreeningListIframe.vue?vue&type=script&lang=ts&"
export * from "./ScreeningListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports